<div class="activities-page">
  <h1>Activity Types</h1>

  <div *ngIf="initialLoading()" class="loading">Loading activity types…</div>
  <div *ngIf="error()" class="lm-error-text">{{ error() }}</div>
  <div *ngIf="success()" class="success">{{ success() }}</div>

  <section class="activity-list">
    <h2>Time blocks</h2>
    <ul>
      <li *ngFor="let activityType of timeBlockActivityTypes()" class="activity-item">
        <div class="activity-main">
          <strong>{{ activityType.name }}</strong>
          <span class="lm-badge">{{ activityType.kind }}</span>
          <span
            class="lm-badge"
            [class.lm-badge--work]="activityType.category === 'WORK'"
            [class.lm-badge--personal]="activityType.category === 'PERSONAL'">
            {{ activityType.category }}
          </span>
          <span class="lm-badge">{{ resolveScheduleTypeLabel(activityType.scheduleType) }}</span>
          <span class="minutes">
            {{ activityType.defaultMinutes === null ? 'No default minutes' : activityType.defaultMinutes + ' min' }}
          </span>
        </div>
        <div class="activity-actions">
          <button type="button" class="lm-btn" (click)="startEdit(activityType)" [disabled]="saving() || isDeleting(activityType.id)">Edit</button>
          <button type="button" class="lm-btn lm-btn--danger" (click)="delete(activityType)" [disabled]="saving() || isDeleting(activityType.id)">
            {{ isDeleting(activityType.id) ? 'Deleting…' : 'Delete' }}
          </button>
        </div>
      </li>
      <li *ngIf="!initialLoading() && timeBlockActivityTypes().length === 0" class="empty">No time blocks yet.</li>
    </ul>
  </section>

  <section class="activity-list">
    <h2>Habits</h2>
    <p class="archive-note">This saved order is the base sequence on Today. Completed habits move to the bottom for the current day only.</p>
    <ul>
      <li *ngFor="let activityType of habitActivityTypes(); let i = index" class="activity-item">
        <div class="activity-main">
          <strong>{{ activityType.name }}</strong>
          <span class="lm-badge">{{ activityType.kind }}</span>
          <span
            class="lm-badge"
            [class.lm-badge--work]="activityType.category === 'WORK'"
            [class.lm-badge--personal]="activityType.category === 'PERSONAL'">
            {{ activityType.category }}
          </span>
          <span class="lm-badge">Habits tab</span>
        </div>
        <div class="activity-actions">
          <span class="habit-reorder-controls">
            <button
              type="button"
              class="lm-icon-btn habit-order-button"
              [disabled]="!canMoveHabit(i, -1)"
              (click)="moveHabit(i, -1)"
              aria-label="Move habit up"
              title="Move habit up">
              <svg lucideArrowUp class="lm-icon" aria-hidden="true"></svg>
            </button>
            <button
              type="button"
              class="lm-icon-btn habit-order-button"
              [disabled]="!canMoveHabit(i, 1)"
              (click)="moveHabit(i, 1)"
              aria-label="Move habit down"
              title="Move habit down">
              <svg lucideArrowDown class="lm-icon" aria-hidden="true"></svg>
            </button>
          </span>
          <button type="button" class="lm-btn" (click)="startEdit(activityType)" [disabled]="saving() || reordering() || isDeleting(activityType.id)">Edit</button>
          <button type="button" class="lm-btn lm-btn--danger" (click)="delete(activityType)" [disabled]="saving() || reordering() || isDeleting(activityType.id)">
            {{ isDeleting(activityType.id) ? 'Deleting…' : 'Delete' }}
          </button>
        </div>
      </li>
      <li *ngIf="!initialLoading() && habitActivityTypes().length === 0" class="empty">No habits yet.</li>
    </ul>
    <p class="archive-note">Delete archives a type via soft delete, so it no longer appears in active lists.</p>
  </section>

  <section class="activity-form">
    <h2>{{ isEditing() ? 'Edit activity type' : 'Create activity type' }}</h2>
    <form (ngSubmit)="submit()">
      <div class="form-group">
        <label for="activity-name">Name</label>
        <input
          id="activity-name"
          name="name"
          type="text"
          [(ngModel)]="name"
          maxlength="100"
          required
          placeholder="e.g. Focused Work"
        />
      </div>

      <div class="form-group">
        <label for="activity-kind">Kind</label>
        <select id="activity-kind" name="kind" [(ngModel)]="kind" (ngModelChange)="onKindChange($event)">
          <option *ngFor="let k of kinds" [value]="k">{{ k }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="activity-category">Category</label>
        <select id="activity-category" name="category" [(ngModel)]="category">
          <option *ngFor="let c of categories" [value]="c">{{ c }}</option>
        </select>
      </div>

      <div *ngIf="kind === 'TIME_BLOCK'" class="form-group">
        <label for="activity-schedule-type">Schedule type</label>
        <select id="activity-schedule-type" name="scheduleType" [(ngModel)]="scheduleType">
          <option *ngFor="let schedule of enabledScheduleTypes()" [value]="schedule">
            {{ resolveScheduleTypeLabel(schedule) }}
          </option>
        </select>
      </div>

      <div *ngIf="kind === 'TIME_BLOCK'" class="form-group">
        <label for="activity-default-minutes">Default minutes (optional)</label>
        <input
          id="activity-default-minutes"
          name="defaultMinutes"
          type="number"
          [(ngModel)]="defaultMinutes"
          [min]="minDefaultMinutes"
          [max]="maxDefaultMinutes"
          placeholder="e.g. 40"
        />
      </div>
      <p *ngIf="kind === 'HABIT_COUNTER'" class="archive-note">
        Habit counters appear in the Habits tab and are not part of the Day status work sequence.
      </p>

      <div class="form-actions">
        <button type="submit" class="lm-btn lm-btn--primary" [disabled]="saving() || !name.trim()">
          {{ saving() ? 'Saving…' : (isEditing() ? 'Save changes' : 'Create activity type') }}
        </button>
        <button *ngIf="isEditing()" type="button" class="lm-btn" (click)="cancelEdit()" [disabled]="saving()">Cancel</button>
      </div>
    </form>
  </section>
</div>
